
const sharedErrorsMsg ={
    EMPTY: "errors.shared.empty"
}


const requiredField = (value)=>{
    if (!value || typeof value !== 'string') {
        return { ok: false, error: sharedErrorsMsg.EMPTY };
    }
    return {ok:true,error:null}
}

const namesErrorsMsg = {
    SYMBOLS: "errors.names.symbols",
    LENGTH : "errors.names.length_2"
}


const validateName = (name) => {
    const nameRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ\s'-]+$/;
    if (!name || typeof name !== 'string') return {ok:false,error:sharedErrorsMsg.EMPTY}; 
    if(!nameRegex.test(name.trim())) return {ok:false,error:namesErrorsMsg.SYMBOLS};
    if(name.length<2) return {ok:false,error:namesErrorsMsg.LENGTH};
    return  {ok:true,error:null};
};

const phoneNumberErrMsg = {
    INVALID : "errors.phone.invalid"
}

const validatePhoneNumber = (phoneNumber) => {
    const regexFrance = /^\+33\s?0?\d{9}$/; // France (+33) 
    const regexDOMTOM = /^\+262\s?0?\d{9}$|^\+596\s?\d{9}$|^\+590\s?\d{9}$/; // DOM-TOM
    const regexMaroc = /^\+212\s?0?\d{9}$/; // Morocco (+212) 
    const regexSpain = /^\+34\s?0?\d{9}$/; // Spain (+34) 

    if (regexFrance.test(phoneNumber)) {
        return {ok:true,error:null}; 
    } else if (regexDOMTOM.test(phoneNumber)) {
        return {ok:true,error:null}; 
    } else if (regexMaroc.test(phoneNumber)) {
        return {ok:true,error:null}; 
    } else if (regexSpain.test(phoneNumber)) {
        return {ok:true,error:null}; 
    } else {
        return {ok:false,error:phoneNumberErrMsg.INVALID}; // Invalid number
    }
};


const emailErrorsMsg = {
    INVALID: "errors.email.invalid",
    UNMATCH_EMAIL: "errors.email.unmatch"
};

const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    if (!email || typeof email !== 'string') {
        return { ok: false, error: sharedErrorsMsg.EMPTY };
    }
    if (!emailRegex.test(email.trim())) {
        return { ok: false, error: emailErrorsMsg.INVALID };
    }
    return { ok: true, error: null };
};

const validateConfirmEmail = (email,confirmEmail)=>{
    const emailValid = validateEmail(email)
    if(emailValid.ok){
        if(email !== confirmEmail) return {ok:false,error:emailErrorsMsg.UNMATCH_EMAIL}
        else return {ok:true,error:null};
    }else return emailValid
}

const zipCodeErrMsg = {
    INVALID: "errors.zipcode.invalid"
}

const validateZipCode = (zipcode)=>{
    if (!zipcode || typeof zipcode !== 'string') return { ok: false, error: sharedErrorsMsg.EMPTY };
    if(zipcode.length<5) return {ok:false,error: zipCodeErrMsg.INVALID}
    return {ok:true,error:null}
}

const birthdateErrorsMsg = {
    INVALID_DATE: "errors.birthdate.invalide",
    UNDERAGE: "errors.birthdate.underage"
};

const validateBirthdate = (birthdate) => {
    if (!birthdate) return { ok: false, error: sharedErrorsMsg.EMPTY };

    const birthdateObj = new Date(birthdate);
    if (isNaN(birthdateObj.getTime())) return { ok: false, error: birthdateErrorsMsg.INVALID_DATE };

    const today = new Date();
    let age = today.getFullYear() - birthdateObj.getFullYear();
    const monthDiff = today.getMonth() - birthdateObj.getMonth();
    const dayDiff = today.getDate() - birthdateObj.getDate();

    // Adjust age if the birthday hasn't occurred yet this year
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age--;
    }

    if (age < 14) return { ok: false, error: birthdateErrorsMsg.UNDERAGE };

    return { ok: true, error: null };
};


const ibanErrMsg = {
    INVALID:"errors.iban.invalid",
    FORMAT:"errors.iban.format"
}

const validateIBAN = (iban) => {
    // Remove spaces and convert to uppercase
    const sanitizedIban = iban.replace(/\s+/g, '').toUpperCase();
    const ibanRegex = /^[A-Z0-9]+$/;
    
    if (!ibanRegex.test(sanitizedIban)) {
        return { ok: false, error: ibanErrMsg.FORMAT };
    }

    // Rearrange the IBAN for checksum validation
    const rearrangedIban = sanitizedIban.slice(4) + sanitizedIban.slice(0, 4);
    const numericIban = rearrangedIban.split('').map(char => {
        const code = char.charCodeAt(0);
        return code >= 65 ? (code - 55).toString() : char; // Convert letters to numbers
    }).join('');

    // Validate checksum
    // eslint-disable-next-line no-undef
    const mod97 = BigInt(numericIban) % 97n;
    if (mod97 !== 1n) {
        return { ok: false, error: ibanErrMsg.INVALID };
    }

    return { ok: true, error: null };
};


const bicErrMsg = {
    INVALID:"errors.bic.invalid"
}

const validateBIC = (bic) => {
    const bicRegex = /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/;
    
    if (!bicRegex.test(bic)) {
        return { ok: false, error: bicErrMsg.INVALID };
    }

    return { ok: true, error: null };
};


export const Validators = {
    requiredField,
    validateName,
    validatePhoneNumber,
    validateEmail,
    validateConfirmEmail,
    validateZipCode,
    validateBirthdate,
    validateIBAN,
    validateBIC
}